














import { Component, Vue } from 'vue-property-decorator';
import global from '../../utils/global';
@Component({})
export default class UserMenu extends Vue {
  private userType: number = global.getUserType();
}
